<p-card styleClass="very-compact-card p-3">
  <div class="flex align-items-center justify-content-between flex-wrap gap-2">
    <div class="flex align-items-center gap-2">
      <h3 class="m-0">Договоры</h3>
      <crm-button-show-and-hide
        [isShow]="contractsShow"
        (isShowChange)="showButtonChange.emit($event)"></crm-button-show-and-hide>

      <button
        *ngIf="contractsShow && isDisplayCreate"
        pButton
        pTooltip="Создать договор"
        tooltipPosition="top"
        icon="pi pi-plus"
        class="p-button-success-create"
        (click)="createContract.emit()"></button>
    </div>
  </div>

  <div
    *ngIf="contractsShow"
    class="mt-3">
    <crm-table
      *ngIf="!loading && contracts?.length"
      name="{{ source }}.contracts"
      [values]="contracts"
      [columns]="columns"
      [loading]="loading"
      styleClass="sticky-header p-datatable-sm">
      <ng-template
        #rowTemplate
        let-contract="item">
        <ng-container *ngIf="toContract(contract) as contract">
          <tr>
            <td *ngIf="source !== CardWidgetTypeEnum.CONTRAGENT">
              <a
                crmConditionalRouterLink
                [routerLink]="['/client/contragent/card/', contract.contragent?.id]">
                {{ contract.contragent?.name }}
              </a>
            </td>
            <td>
              <a
                class="white-space-nowrap"
                crmConditionalRouterLink
                [routerLink]="['/client/contract/card/', contract.id]">
                {{ contract.name }}
              </a>
            </td>
            <td>{{ contract.number }}</td>
            <td>{{ contract.date | date: 'dd.MM.yyyy' }}</td>
            <td>
              {{ contract.status | contractStatusType }}
            </td>
          </tr>
        </ng-container>
      </ng-template>
    </crm-table>

    <p
      *ngIf="!contracts?.length && !loading"
      class="text-xl font-medium">
      Нет договоров
    </p>

    <a
      *ngIf="!loading"
      pButton
      [label]="getContractsLabel()"
      class="p-button-round p-button-text p-button-sm p-button-info cursor-pointer -ml-3"
      icon="pi pi-external-link"
      (click)="isShowCount ? navigateToContractList.emit() : directToContractList()"></a>

    <crm-spinner
      *ngIf="loading"
      top="mt-4"></crm-spinner>
  </div>
</p-card>
